module.exports = __webpack_public_path__ + "img/timestudy-6.aae5d838.png";